import {jwtDecode} from "jwt-decode";
import { DecodedJwtToken } from "../interface/interfaces";



export function isTokenExpired(token: string): boolean {
  try {
    const decoded = jwtDecode<DecodedJwtToken>(token);
    const now = Date.now() / 1000;
    return decoded.exp < now;
  } catch {
    return true;
  }
}
